import { usePrismicDocumentByUID } from "@prismicio/react";
import React from "react";
import PageContent from "../components/PageContent";

export default function Culture() {
    const [document] = usePrismicDocumentByUID('gcc_content_page', 'culture');
    return <PageContent document={document} sectionClass='culture' />;
}